/**
 * ActiveMediaList - Lista de mídias ativas
 * Módulo Motorista - Sistema IDOOH
 */

import React from 'react';
import { Play, Image as ImageIcon } from 'lucide-react';
import { CampaignMedia } from '../types/dashCompanion';
import { MediaItemCard } from './MediaItemCard';

interface ActiveMediaListProps {
    medias: CampaignMedia[];
    onRemove: (mediaId: string) => void;
    onView?: (media: CampaignMedia) => void;
}

export function ActiveMediaList({ medias, onRemove, onView }: ActiveMediaListProps) {
    if (medias.length === 0) {
        return (
            <div className="bg-gradient-to-br from-emerald-600 to-green-700 rounded-2xl p-8 text-center shadow-lg">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <ImageIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-white font-medium mb-1">Nenhuma mídia em veiculação</h3>
                <p className="text-sm text-white/70">
                    Ative um pack de mídias para começar a monetizar
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between px-1">
                <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                    <Play className="w-5 h-5 text-emerald-600" />
                    Mídias em Veiculação
                </h2>
                <span className="text-sm text-emerald-600 font-medium">{medias.length} mídia(s)</span>
            </div>

            <div className="space-y-2">
                {medias.map(media => (
                    <MediaItemCard
                        key={media.id}
                        media={media}
                        onRemove={onRemove}
                        onView={onView}
                    />
                ))}
            </div>
        </div>
    );
}

export default ActiveMediaList;
